// F5: the app never uses Supabase Realtime or Storage, but supabase-js builds both clients on start, which put
// ~84 KB (realtime-js, phoenix, storage-js, iceberg-js) in the first download. vite.config.ts points those two packages
// here. supabase-js only constructs them and hands Realtime the session token; anything more fails loudly, so a future
// use of either shows up at once (remove the alias in vite.config.ts to use them). The build fails if supabase-js
// starts importing a name this file does not export.
const unused = (what: string) => new Error(`Supabase ${what} is not bundled in this app (see app/src/lib/supabaseUnused.ts)`)

export class RealtimeClient {
  constructor(_url?: string, _options?: unknown) {}
  setAuth(_token?: string | null): Promise<void> { return Promise.resolve() }
  channel(): never { throw unused('Realtime') }
  getChannels(): never[] { return [] }
  removeChannel(): Promise<'ok'> { return Promise.resolve('ok') }
  removeAllChannels(): Promise<'ok'[]> { return Promise.resolve([]) }
}

export class StorageClient {
  constructor(_url?: string, _headers?: unknown, _fetch?: unknown, _options?: unknown) {}
  from(): never { throw unused('Storage') }
}

export class StorageApiError extends Error {}
